import { Controller } from "@hotwired/stimulus";

const VALIDATED_FLAG = "__depozenEmbedValidatedPosted";

export default class extends Controller {
  connect() {
    this.boundResetValidatedFlag = this.resetValidatedFlag.bind(this);
    document.addEventListener("turbo:load", this.boundResetValidatedFlag);
    this.postValidatedMessageOnce();
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundResetValidatedFlag);
  }

  resetValidatedFlag() {
    window[VALIDATED_FLAG] = false;
  }

  postValidatedMessageOnce() {
    if (window.parent === window) return;
    if (window[VALIDATED_FLAG]) return;

    window[VALIDATED_FLAG] = true;

    const payload = { type: "formulr:iframeModuleValidated" };
    console.log("[Depozen embed] postMessage → parent", payload);
    window.parent.postMessage(payload, "*");
  }
}
